/**
 * Hero-Slideshow.
 *
 * Bewusst zurueckhaltend: nur Fades, kein Autoplay auf Mobil und keines bei
 * `prefers-reduced-motion` (Design-System, Artefakt 09/10). Der Ausgangszustand
 * ist immer sichtbar — ohne JS steht der erste Slide, nichts ist versteckt.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 639px)').matches;

  /**
   * Nachgereichte Slide-Bilder.
   *
   * Ab dem zweiten Slide liefert Liquid nur `data-src`/`data-srcset`, damit
   * beim Seitenaufbau nicht drei Vollbilder gleichzeitig geladen werden.
   * `loading="lazy"` half hier nicht: Alle Slides liegen uebereinander im
   * sichtbaren Bereich und gelten dem Browser deshalb als sichtbar.
   *
   * Eingetragen wird im Leerlauf nach dem Laden — spaetestens aber, wenn der
   * Slide tatsaechlich gezeigt werden soll.
   */
  function bildNachladen(bereich) {
    (bereich || document).querySelectorAll('img[data-slide-lazy]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-slide-lazy');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  var imLeerlauf =
    window.requestIdleCallback ||
    function (fn) {
      return setTimeout(fn, 1500);
    };

  if (document.readyState === 'complete') {
    imLeerlauf(function () {
      bildNachladen(document);
    });
  } else {
    window.addEventListener('load', function () {
      imLeerlauf(function () {
        bildNachladen(document);
      });
    });
  }

  document.querySelectorAll('[data-slides]').forEach(function (track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.slide'));
    if (slides.length < 2) return;

    var root = track.closest('.hero');
    var dots = root ? Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]')) : [];
    var index = 0;
    var timer = null;

    function show(next) {
      index = (next + slides.length) % slides.length;

      /* Sicherheitsnetz: Wird ein Slide gebraucht, bevor der Leerlauf kam,
         holen wir sein Bild sofort — sonst bliebe die Flaeche kurz leer. */
      bildNachladen(slides[index]);

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.slideDot, 10));
        stop();
      });
    });

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    var interval = parseInt(track.dataset.autoplay, 10);

    if (interval && !reduceMotion && !isMobile) {
      timer = window.setInterval(function () {
        show(index + 1);
      }, interval * 1000);

      /* Im Hintergrundtab nicht weiterlaufen. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
      });
    }
  });
})();
